/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Show_Event_AriaInputs */

const en_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Event Shortcut`)
};

const fr_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourci afficher l'evenement`)
};

const de_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfung zum Show-Event`)
};

const it_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra collegamento evento`)
};

const ru_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать ярлык события`)
};

const es_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar acceso directo al evento`)
};

const zh_cn2_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示活动快捷方式`)
};

const ja_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのショートカットを表示`)
};

const hi_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट शॉर्टकट दिखाएँ`)
};

const pt_pt2_timing_sync_show_event_aria = /** @type {(inputs: Timing_Sync_Show_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atalho para Mostrar Evento`)
};

/**
* | output |
* | --- |
* | "Show Event Shortcut" |
*
* @param {Timing_Sync_Show_Event_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_show_event_aria = /** @type {((inputs?: Timing_Sync_Show_Event_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Show_Event_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_show_event_aria(inputs)
	if (locale === "de") return de_timing_sync_show_event_aria(inputs)
	if (locale === "it") return it_timing_sync_show_event_aria(inputs)
	if (locale === "ru") return ru_timing_sync_show_event_aria(inputs)
	if (locale === "es") return es_timing_sync_show_event_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_show_event_aria(inputs)
	if (locale === "ja") return ja_timing_sync_show_event_aria(inputs)
	if (locale === "hi") return hi_timing_sync_show_event_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_show_event_aria(inputs)
	return en_timing_sync_show_event_aria(inputs)
});